// =============================================================================
// VM Agent Control Messages (WebSocket protocol)
// =============================================================================
/** All known control message type strings */
const CONTROL_MESSAGE_TYPES = new Set([
    'agent_status',
    'agent_crash_report',
    'select_agent',
    'session_state',
    'session_replay_complete',
    'session_prompting',
    'session_prompt_done',
    'ping',
    'pong',
]);
/** Check if a parsed message is a control message (vs ACP JSON-RPC) */
export function isControlMessage(msg) {
    return (typeof msg === 'object' &&
        msg !== null &&
        'type' in msg &&
        CONTROL_MESSAGE_TYPES.has(msg.type));
}
//# sourceMappingURL=types.js.map